import React from 'react'
import communesData from './communes-data.csv'
import communesGeo from './communes-geo.json'
import districtsGeo from './districts-geo.json'
import cantonGeo from './canton-geo.json'

import { InteractiveMap } from 'components/interactiveMap'
import { feature } from 'topojson-client'

console.log(communesGeo)

const cantonTopo = feature(cantonGeo, cantonGeo.objects['vd-canton-4326'])

const districtsTopo = feature(
  districtsGeo,
  districtsGeo.objects['vd-districts-4326']
)

const communesTopo = feature(
  communesGeo,
  communesGeo.objects['vd-communes-4326-small']
)

interface Props {
  data: { id: string; pct: number; count: number }[]
}

export const Map = ({ data = [] }: Props) => (
  <InteractiveMap
    canton={cantonTopo}
    districts={districtsTopo}
    geodata={communesTopo}
    data={data}
  />
)
